import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import NavLink from '../nav_link';
import PropTypes from 'prop-types';

const styles = (theme) => ({
    topic: {
        height: '100%',
        padding: '0 0 0 34px',
    },
    line: {
        width: '0px',
        position: 'absolute',
        height: 'inherit',
        borderLeft: `1px solid ${theme.palette.divider}`,
        borderRight: `1px solid ${theme.palette.divider}`,
    },
    lineActive: {
        width: '0px',
        backgroundColor: 'black',
        border: '1px solid black',
        position: 'absolute',
        height: 'inherit',
    },
    listItem: {
        margin: '0px',
        padding: '0px 16px',
    },
});

function VerticalNavLink({ to = '#', secondary, classes, onActive, onClick }) {
    return (
        <NavLink to={to} onActive={onActive} onClick={onClick}>
            <ListItem button className={classes.topic}>
                {location.pathname.includes(to) ? (
                    <Divider orientation="vertical" className={classes.lineActive} />
                ) : (
                    <Divider orientation="vertical" className={classes.line} />
                )}
                <ListItemText secondary={secondary} className={classes.listItem} />
            </ListItem>
        </NavLink>
    );
}

VerticalNavLink.propTypes = {
    to: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    secondary: PropTypes.string.isRequired,
    onActive: PropTypes.func.isRequired,
    topic: PropTypes.object,
};

export default withStyles(styles)(VerticalNavLink);
